/**
 * CMS page slugs — PascalCase, no dashes.
 * URLs: /pages/{PageSlugs.messageFromCeo}
 */
export const PageSlugs = {
  // Hub pages
  weAreMayar: 'WeAreMayar',
  ourCommitment: 'OurCommitment',
  ourSchools: 'OurSchools',
  ourStudents: 'OurStudents',
  newsEvents: 'NewsEvents',
  forParents: 'ForParents',
  admissions: 'Admissions',
  admissionRegistration: 'AdmissionRegistration',
  transferringCertification: 'TransferringCertification',
  schoolDivisions: 'SchoolDivisions',

  // School Divisions — Kindergarten
  kgCurriculum: 'KgCurriculum',
  kgDailySchedule: 'KgDailySchedule',
  kindergarten: 'Kindergarten',
  kgGuidelines: 'KgGuidelines',

  // School Divisions — Primary
  earlyPrimary: 'EarlyPrimary',
  epNationalCurriculum: 'EpNationalCurriculum',
  epDailyTimetables: 'EpDailyTimetables',
  epInternationalCurriculum: 'EpInternationalCurriculum',
  epGuidelines: 'EpGuidelines',
  epAssessmentPolicy: 'EpAssessmentPolicy',
  primaryGrades46: 'PrimaryGrades46',
  pgNationalCurriculum: 'PgNationalCurriculum',
  pgInternationalCurriculum: 'PgInternationalCurriculum',
  pgDailyTimetables: 'PgDailyTimetables',
  pgGuidelines: 'PgGuidelines',

  // School Divisions — Middle School
  msNationalCurriculum: 'MsNationalCurriculum',
  msDailyTimetables: 'MsDailyTimetables',
  msInternationalCurriculum: 'MsInternationalCurriculum',
  aboutMiddleSchool: 'AboutMiddleSchool',
  msGuidelines: 'MsGuidelines',

  // School Divisions — High School
  hsNational: 'HsNational',
  hsBritishProgram: 'HsBritishProgram',
  hsBritishTawjihi: 'HsBritishTawjihi',
  hsBritishCurriculum: 'HsBritishCurriculum',
  hsAmericanProgram: 'HsAmericanProgram',
  hsAmericanTawjihi: 'HsAmericanTawjihi',
  hsAmericanCurriculum: 'HsAmericanCurriculum',

  // Services & Facilities
  serviceCounseling: 'ServiceCounseling',
  serviceClubs: 'ServiceClubs',
  serviceTransportation: 'ServiceTransportation',
  serviceCanteen: 'ServiceCanteen',
  serviceClinic: 'ServiceClinic',
  serviceLibrary: 'ServiceLibrary',
  serviceMusic: 'ServiceMusic',
  serviceLabs: 'ServiceLabs',
  serviceAuditorium: 'ServiceAuditorium',
  servicePlaygrounds: 'ServicePlaygrounds',

  // We Are Mayar
  messageFromCeo: 'MessageFromCEO',
  visionMissionValues: 'VisionMissionValues',
  leadership: 'Leadership',
  accreditations: 'Accreditations',
  communityPartnerships: 'CommunityPartnerships',
  studentCouncil: 'StudentCouncil',
  weeklySchedule412: 'WeeklySchedule412',


  // Our Commitment
  mayarDifference: 'MayarDifference',
  valuesCharacter: 'ValuesCharacter',
  academicExcellence: 'AcademicExcellence',
  beyondClassroom: 'BeyondClassroom',
  sustainability: 'Sustainability',
  universityCareerPathways: 'UniversityCareerPathways',
  realWorldReadiness: 'RealWorldReadiness',
  inclusionLearningSupport: 'InclusionLearningSupport',
  wellbeingCounseling: 'WellbeingCounseling',
  studentSafety: 'StudentSafety',
  arabicNonNative: 'ArabicNonNative',

  // Our Schools
  schoolsByProgram: 'SchoolsByProgram',
  nationalProgram: 'NationalProgram',
  britishProgram: 'BritishProgram',
  americanProgram: 'AmericanProgram',
  misTlaAlAli: 'MisTlaAlAli',
  misKhalda: 'MisKhalda',
  campuses: 'Campuses',
  branches: 'Branches',
  allOurSchools: 'AllOurSchools',
  parentTestimonials: 'ParentTestimonials',

  // Our Students
  alumni: 'Alumni',
  studentExperiences: 'StudentExperiences',

  // News & Events (CMS pages)
  news: 'News',
  schoolEvents: 'SchoolEvents',

  // For Parents
  choosingProgram: 'ChoosingProgram',
  pathwaysChoices: 'PathwaysChoices',
  mayarForWorld: 'MayarForWorld',
  mayarApp: 'MayarApp',
  privacy: 'privacy',
  terms: 'terms',
}

/** @deprecated kebab-case slugs → redirect to PascalCase */
export const LegacyPageSlugRedirects = {
  'we-are-mayar': PageSlugs.weAreMayar,
  'our-commitment': PageSlugs.ourCommitment,
  'our-schools': PageSlugs.ourSchools,
  'our-students': PageSlugs.ourStudents,
  'news-events': PageSlugs.newsEvents,
  'for-parents': PageSlugs.forParents,
  'message-from-ceo': PageSlugs.messageFromCeo,
  'vision-mission-values': PageSlugs.visionMissionValues,
  leadership: PageSlugs.leadership,
  accreditations: PageSlugs.accreditations,
  'community-partnerships': PageSlugs.communityPartnerships,
  'mayar-difference': PageSlugs.mayarDifference,
  'values-character': PageSlugs.valuesCharacter,
  'academic-excellence': PageSlugs.academicExcellence,
  'beyond-classroom': PageSlugs.beyondClassroom,
  sustainability: PageSlugs.sustainability,
  'university-career-pathways': PageSlugs.universityCareerPathways,
  'real-world-readiness': PageSlugs.realWorldReadiness,
  'inclusion-learning-support': PageSlugs.inclusionLearningSupport,
  'wellbeing-counseling': PageSlugs.wellbeingCounseling,
  'student-safety': PageSlugs.studentSafety,
  'arabic-non-native': PageSlugs.arabicNonNative,
  'schools-by-program': PageSlugs.allOurSchools,
  'national-program': PageSlugs.nationalProgram,
  'british-program': PageSlugs.britishProgram,
  'american-program': PageSlugs.americanProgram,
  'mis-tla-al-ali': PageSlugs.misTlaAlAli,
  'mis-khalda': PageSlugs.misKhalda,
  branches: PageSlugs.campuses,
  'all-our-schools': PageSlugs.allOurSchools,
  'parent-testimonials': PageSlugs.parentTestimonials,
  alumni: PageSlugs.alumni,
  'student-experiences': PageSlugs.studentExperiences,
  news: PageSlugs.news,
  'school-events': PageSlugs.schoolEvents,
  'choosing-program': PageSlugs.choosingProgram,
  'pathways-choices': PageSlugs.pathwaysChoices,
  'mayar-for-world': PageSlugs.mayarForWorld,
  'mayar-app': PageSlugs.mayarApp,
}

/** Hub landing pages removed from the public site — redirect to home if visited. */
export const REMOVED_HUB_SLUGS = [
  PageSlugs.weAreMayar,
  PageSlugs.ourCommitment,
  PageSlugs.ourSchools,
  PageSlugs.ourStudents,
  PageSlugs.newsEvents,
  PageSlugs.forParents,
  PageSlugs.admissions,
  PageSlugs.schoolDivisions,
]

/** Additional CMS pages removed from the public site. */
export const REMOVED_PAGE_SLUGS = [
  ...REMOVED_HUB_SLUGS,
  PageSlugs.allOurSchools,
]

/** @deprecated use REMOVED_HUB_SLUGS */
export const HUB_SLUGS = REMOVED_HUB_SLUGS

export const PROGRAM_PAGES = [
  PageSlugs.nationalProgram,
  PageSlugs.britishProgram,
  PageSlugs.americanProgram,
]

export const DIVISION_SECTION_GROUPS = {
  [PageSlugs.earlyPrimary]: {
    items: [
      {
        slug: PageSlugs.earlyPrimary,
        title_en: 'About Early Primary School',
        title_ar: 'عن المرحلة الأساسية الأولى',
      },
      {
        slug: PageSlugs.epNationalCurriculum,
        title_en: 'Curriculum for National Section',
        title_ar: 'المنهاج الوطني',
      },
      {
        slug: PageSlugs.epDailyTimetables,
        title_en: 'Daily Timetables',
        title_ar: 'جداول الحصص',
      },
      {
        slug: PageSlugs.epInternationalCurriculum,
        title_en: 'Curriculum for International Section',
        title_ar: 'المنهاج الدولي',
      },
      {
        slug: PageSlugs.epGuidelines,
        title_en: 'Instructions and Guidelines',
        title_ar: 'التعليمات والإرشادات',
      },
      {
        slug: PageSlugs.epAssessmentPolicy,
        title_en: 'Assessment Policy',
        title_ar: 'سياسة التقييم',
      },
    ],
  },
  [PageSlugs.primaryGrades46]: {
    items: [
      {
        slug: PageSlugs.primaryGrades46,
        title_en: 'About Primary School',
        title_ar: 'عن المرحلة الأساسية',
      },
      {
        slug: PageSlugs.pgNationalCurriculum,
        title_en: 'Curriculum for National Section',
        title_ar: 'المنهاج الوطني',
      },
      {
        slug: PageSlugs.pgInternationalCurriculum,
        title_en: 'Curriculum for International Section',
        title_ar: 'المنهاج الدولي',
      },
      {
        slug: PageSlugs.pgDailyTimetables,
        title_en: 'Daily Timetables',
        title_ar: 'جداول الحصص',
      },
      {
        slug: PageSlugs.pgGuidelines,
        title_en: 'Instructions and Guidelines',
        title_ar: 'التعليمات والإرشادات',
      },
    ],
  },
}

export const DIVISION_SECTION_SLUGS = Object.values(DIVISION_SECTION_GROUPS).flatMap((group) =>
  group.items.map((item) => item.slug)
)

export function getDivisionSectionGroup(slug) {
  for (const group of Object.values(DIVISION_SECTION_GROUPS)) {
    if (group.items.some((item) => item.slug === slug)) {
      return group
    }
  }

  return null
}

export function pagePath(slug) {
  return `/pages/${slug}`
}
